import { render, staticRenderFns } from "./AbsenceRegistrations.vue?vue&type=template&id=64f69ce2&scoped=true&"
import script from "./AbsenceRegistrations.vue?vue&type=script&lang=js&"
export * from "./AbsenceRegistrations.vue?vue&type=script&lang=js&"
import style0 from "./AbsenceRegistrations.vue?vue&type=style&index=0&id=64f69ce2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f69ce2",
  null
  
)

component.options.__file = "AbsenceRegistrations.vue"
export default component.exports